import {
  FETCH_CREATE_TOURNAMENT_REQUEST,
  FETCH_CREATE_TOURNAMENT_SUCCESS,
  FETCH_CREATE_TOURNAMENT_FAILURE,
  RESET_ADMIN_CREATE_TOURNAMENT_REQUEST,
} from '../../types/game';

const initState = {
  data: null,
  error: null,
  isLoading: false,
};

const CreateTournamentReducer = (state = initState, action) => {
  switch (action.type) {
    case FETCH_CREATE_TOURNAMENT_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_CREATE_TOURNAMENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.data.data,
        error: null,
      };
    case FETCH_CREATE_TOURNAMENT_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };
    case RESET_ADMIN_CREATE_TOURNAMENT_REQUEST:
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const updated = {
        ...state,
        ...initState,
      };
      return {
        ...initState,
      };
    default:
      return state;
  }
};

export default CreateTournamentReducer;
